import { useRef, useState } from 'react'
import { isMacOs } from 'react-device-detect'

import CaretDownOutlinedIcon from '@ant-design/icons/CaretDownOutlined'
import LinkOutlinedIcon from '@ant-design/icons/LinkOutlined'
import SnippetsOutlinedIcon from '@ant-design/icons/SnippetsOutlined'
import UploadOutlinedIcon from '@ant-design/icons/UploadOutlined'

import Button from '@mui/material/Button'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@components/_mui/Typography'

import { FileInput } from './DropStrip'

export default function AddMenu({ onFiles, onLink, disabled = false, variant = 'contained' }) {
  const [anchor, setAnchor] = useState(null)
  const [open, setOpen] = useState(false)
  const inputRef = useRef(null)

  const close = () => setOpen(false)

  return (
    <>
      <Button
        ref={setAnchor}
        size="small"
        color="secondary"
        variant={variant}
        disabled={disabled}
        startIcon={<UploadOutlinedIcon />}
        endIcon={<CaretDownOutlinedIcon />}
        onClick={(e) => {
          e.stopPropagation()
          setOpen(true)
        }}
      >
        Add
      </Button>
      <FileInput inputRef={inputRef} onFiles={onFiles} />
      <Menu
        open={open}
        anchorEl={anchor}
        onClose={close}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => {
            close()
            inputRef.current?.click()
          }}
        >
          <ListItemIcon>
            <UploadOutlinedIcon />
          </ListItemIcon>
          <ListItemText>Upload files…</ListItemText>
        </MenuItem>
        <MenuItem disabled sx={{ opacity: '1 !important' }}>
          <ListItemIcon>
            <SnippetsOutlinedIcon />
          </ListItemIcon>
          <ListItemText sx={{ color: 'text.secondary' }}>Paste files</ListItemText>
          <Typography variant="caption" sx={{ color: 'text.secondary', pl: 2 }}>
            {isMacOs ? '⌘V' : 'Ctrl+V'}
          </Typography>
        </MenuItem>
        {onLink && (
          <MenuItem
            onClick={() => {
              close()
              onLink()
            }}
          >
            <ListItemIcon>
              <LinkOutlinedIcon />
            </ListItemIcon>
            <ListItemText>Link patient document…</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </>
  )
}
